import axios from "axios";

// Fall back to same-origin if the env var is missing/stale — the ingress routes
// /api/* to the backend on the same domain, so this always works.
const envUrl = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL =
  envUrl && envUrl !== "undefined" ? envUrl : window.location.origin;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ---- Session security ----
// The session lives in an httpOnly cookie set by the backend (never readable by
// page scripts, so it cannot be stolen via XSS). The token below is kept ONLY in
// memory for the current tab as a fast-path Authorization header; a page refresh
// re-authenticates through the cookie via GET /auth/me.
let memToken = null;
export const getToken = () => memToken;
export const setToken = (token) => {
  memToken = token;
};
export const clearToken = () => {
  memToken = null;
};

// One-time cleanup of legacy web-storage sessions (pre-httpOnly-cookie builds).
try {
  localStorage.removeItem("cx_token");
  sessionStorage.removeItem("cx_token");
  localStorage.removeItem("cx_user");
} catch (e) {
  // Storage may be unavailable (private mode / disabled) — nothing to clean.
  console.warn("Legacy session cleanup skipped:", e?.message || e);
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      clearToken();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail) return typeof detail === "string" ? detail : JSON.stringify(detail);
  if (!e?.response) return "Cannot reach the server. Please check your connection and retry.";
  if (e.response.status === 404)
    return "Server route not found. Please hard-refresh the page (Ctrl/Cmd+Shift+R) and retry.";
  if (e.response.status >= 500) return "Server error. Please retry in a moment.";
  return e?.message || "Something went wrong";
};
